import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParaMilestoneIconComponent } from './para-milestone-icon.component';

@NgModule({
	imports: [CommonModule],
	declarations: [ParaMilestoneIconComponent],
	exports: [ParaMilestoneIconComponent],
})
export class ParaMilestoneIconModule {}
